import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import stocksReducer from './slices/stocksSlice';
import filtersReducer from './slices/filtersSlice';
import databaseReducer from './slices/databaseSlice';
import screeningReducer from './slices/screeningSlice';
import globalMessageReducer from './slices/globalMessageSlice';
import chartReducer from './slices/chartSlice';
import aiAnalysisReducer from './slices/aiAnalysisSlice';
import favoritesReducer from './slices/favoritesSlice';
import analysisPanelReducer from './slices/analysisPanelSlice';
import grokSentimentReducer from './slices/grokSentimentSlice';
import perplexityAnalysisReducer from './slices/perplexityAnalysisSlice';
import modalsReducer from './slices/modalsSlice';
import billingReducer from './slices/billingSlice';
import alertsReducer from './slices/alertsSlice';
import dataUpdateReducer from './slices/dataUpdateSlice';
import flagAgentsReducer from './slices/flagAgentsSlice';
import helpReducer from './slices/helpSlice';
import tvSidecarReducer from './slices/tvSidecarSlice';
import autoScreenReducer from './slices/autoScreenSlice';
import runtimeConfigReducer from './slices/runtimeConfigSlice';
import positionsReducer from './slices/positionsSlice';
import positionAlertsReducer from './slices/positionAlertsSlice';
import positionStatsReducer from './slices/positionStatsSlice';

export const store = configureStore({
  reducer: {
    stocks: stocksReducer,
    filters: filtersReducer,
    database: databaseReducer,
    screening: screeningReducer,
    globalMessage: globalMessageReducer,
    chart: chartReducer,
    aiAnalysis: aiAnalysisReducer,
    favorites: favoritesReducer,
    analysisPanel: analysisPanelReducer,
    dataUpdate: dataUpdateReducer,
    grokSentiment: grokSentimentReducer,
    perplexityAnalysis: perplexityAnalysisReducer,
    modals: modalsReducer,
    billing: billingReducer,
    alerts: alertsReducer,
    flagAgents: flagAgentsReducer,
    help: helpReducer,
    tvSidecar: tvSidecarReducer,
    autoScreen: autoScreenReducer,
    runtimeConfig: runtimeConfigReducer,
    positions: positionsReducer,
    positionAlerts: positionAlertsReducer,
    positionStats: positionStatsReducer,
    // TODO: Re-enable when user-screening-history API is implemented. See src/_archived/
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Add proper typing for dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
